import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-header" }
const _hoisted_2 = { class: "container-fluid position-relative d-flex flex-column align-items-center justify-content-between" }
const _hoisted_3 = { class: "header-logo-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "logo-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "logo-bg" }, null, -1)
const _hoisted_7 = { class: "logo-tagline" }
const _hoisted_8 = {
  id: "navmenu",
  class: "navmenu"
}

import { ref, onMounted, watch, h, computed } from "vue";
import { V1_REDIS_GET_KEY } from "@/api/const/redis";
import { apiPost, apiGetNoParam, apiRedis } from "@/api/index";
import MenuTop from "@/components/Headers/default/menu/MenuTop.vue";
import Drawer from "@/components/ant/drawer/Drawer.vue";
import MenuMobile from "@/components/Headers/default/menu/MenuMobile.vue";
import HeaderMenu from "@/components/Headers/default/menu/HeaderMenu.vue";
import commons from "@/utils/Common";
import router from "@/router";
import redis from '@/redis/Redis'
import { MENU_HEADER_TOP1_COOKIE, COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
import {COOKIE_COMPANY_SESSION} from '@/const/cookie'
import store from "@/store";
import Utils from "@/utils/Utils";
import PageBanner from '@/components/ant/pagebaner/PageBanner.vue'
import DefaultBreadcrumb from '@/components/ant/breadcrumb/DefaultBreadcrumb.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultHeader',
  setup(__props) {

const menuHeader: any = ref([]);
const menuDefault: any = ref([]);

const companys: any = ref({});
onMounted(async () => {
  await informMenu();
  await loadCompanyInform();
});

const showMenu = ref(false);
const showDrawer = () => {
  showMenu.value = true;
};

const informMenu = async () => {
  loadMenuHeaderTop()
  loadMenuDefault()
};

const loadMenuHeaderTop = async () => {
  await apiGetNoParam(
    V1_REDIS_GET_KEY + "?key=menu-top-header"
  ).then((res) => {
    let response: any = res;
    let data = response.data.data
    commons.setLocalStorage(MENU_HEADER_TOP1_COOKIE, data)
    let menuTop = JSON.parse(commons.getLocalStorage(MENU_HEADER_TOP1_COOKIE) || 'null')
    menuHeader.value = menuTop;
  });
}

const loadMenuDefault = async () => {
  await apiRedis("default-menu-header").then((res) => {
    let response: any = res;
    let data = response.data.data
     if (typeof data === "string") {
      data = JSON.parse(data)
    }

    menuDefault.value = data || []


    // commons.setLocalStorage(MENU_HEADER_TOP1_COOKIE, data)
    // let menuTop = JSON.parse(commons.getLocalStorage(MENU_HEADER_TOP1_COOKIE) || 'null')
    // menuHeader.value = menuTop;
  });
}

const loadCompanyInform = async () => {
  await apiRedis("company-infor").then((res) => {
    let response: any = res;
    let data = JSON.parse(response.data.data)
    console.log('company-infor', data[0])
    commons.setCokies(COOKIE_COMPANY_SESSION, data[0])
    companys.value = data[0];
    store.dispatch('setCompanyInfor', data[0])
  });
}

const closePopup = (val: any) => {
  showMenu.value = val;
};

const goHome = () => {
  router.push({ path: "/" });
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_anchor = _resolveComponent("a-anchor")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MenuTop),
      _createElementVNode("div", null, [
        _createVNode(_component_a_layout_header, {
          id: "header",
          class: "header d-flex align-items-center sticky-top"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "logo"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_5, _toDisplayString(companys.value.sub_name), 1),
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, _toDisplayString(companys.value.summary), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("nav", _hoisted_8, [
                _createVNode(_component_a_anchor, { style: {"width":"100% !important"} }, {
                  default: _withCtx(() => [
                    _createVNode(HeaderMenu, {
                      dataMenu: menuDefault.value,
                      onOpenMenuMobile: showDrawer
                    }, null, 8, ["dataMenu"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(Drawer, {
          placement: "left",
          "show-form": showMenu.value,
          onClosePopup: closePopup
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(MenuMobile, { "data-menu": menuDefault.value }, null, 8, ["data-menu"])
            ])
          ]),
          _: 1
        }, 8, ["show-form"])
      ])
    ]),
    _createVNode(PageBanner),
    _createVNode(DefaultBreadcrumb)
  ]))
}
}

})